import type { GetFeaturesResponse, GetOrganizationCapabilitiesResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const featureActions = {
	fetchFeatures: createActionSet<void, GetFeaturesResponse.AsObject>("app/features/fetch"),
	fetchCapabilities: createActionSet<void, GetOrganizationCapabilitiesResponse.AsObject>(
		"app/capabilities/fetch",
	),
};
